// extracted by mini-css-extract-plugin
export var menuIcon = "_qm-0";
export var menuIconInline = "_qm-1";